namespace RioERP.Orders {
    export interface OrderInstallmentsForm {
        OrderId: Serenity.IntegerEditor;
        Amount: Serenity.DecimalEditor;
        InstallmentDate: Serenity.DateEditor;
        EStatus: Serenity.EnumEditor;
        Note: Serenity.StringEditor;
    }

    export class OrderInstallmentsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderInstallments';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderInstallmentsForm.init)  {
                OrderInstallmentsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;
                var w3 = s.EnumEditor;
                var w4 = s.StringEditor;

                Q.initFormType(OrderInstallmentsForm, [
                    'OrderId', w0,
                    'Amount', w1,
                    'InstallmentDate', w2,
                    'EStatus', w3,
                    'Note', w4
                ]);
            }
        }
    }
}
